(function (global) {
  'use strict';

  // Internal planning estimate only; this does not represent a supplier freight charge.
  const INTERNAL_FREIGHT_BUFFER_NET_CENTS = 5000;
  const ESTIMATE_STATUS = 'JEREMIAS_FREIGHT_COST_ESTIMATED_50_EUR_NET';
  const CORE_PRICES_CENTS = Object.freeze({
  "130:H1": 90990,
  "130:H2": 94990,
  "130:H3": 97990,
  "130:H4": 104990,
  "130:H5": 101990,
  "130:H6": 110990,
  "130:H7": 125990,
  "130:H8": 133990,
  "130:H9": 144990,
  "130:H10": 154990,
  "130:H11": 170990,
  "150:H1": 94990,
  "150:H2": 99990,
  "150:H3": 104990,
  "150:H4": 109990,
  "150:H5": 106990,
  "150:H6": 116990,
  "150:H7": 133990,
  "150:H8": 145990,
  "150:H9": 156990,
  "150:H10": 168990,
  "150:H11": 185990,
  "160:H1": 96990,
  "160:H2": 102990,
  "160:H3": 107990,
  "160:H4": 112990,
  "160:H5": 108990,
  "160:H6": 120990,
  "160:H7": 138990,
  "160:H8": 150990,
  "160:H9": 163990,
  "160:H10": 175990,
  "160:H11": 194990,
  "180:H1": 98990,
  "180:H2": 105990,
  "180:H3": 111990,
  "180:H4": 116990,
  "180:H5": 111990,
  "180:H6": 124990,
  "180:H7": 144990,
  "180:H8": 157990,
  "180:H9": 170990,
  "180:H10": 184990,
  "180:H11": 203990,
  "200:H1": 108990,
  "200:H2": 116990,
  "200:H3": 122990,
  "200:H4": 128990,
  "200:H5": 122990,
  "200:H6": 137990,
  "200:H7": 158990,
  "200:H8": 173990,
  "200:H9": 188990,
  "200:H10": 203990,
  "200:H11": 224990
});
  const WALL_DISTANCE_DELTAS_CENTS = Object.freeze({
  "130:1:50": -1900,
  "130:1:100": 0,
  "130:1:150": 0,
  "130:1:200": 2100,
  "130:1:250": 2100,
  "130:1:300": 4400,
  "130:1:360": 6600,
  "130:2:50": -3800,
  "130:2:100": 0,
  "130:2:150": 0,
  "130:2:200": 3200,
  "130:2:250": 3200,
  "130:2:300": 7800,
  "130:2:360": 10000,
  "130:3:50": -5700,
  "130:3:100": 0,
  "130:3:150": 0,
  "130:3:200": 4300,
  "130:3:250": 4300,
  "130:3:300": 11200,
  "130:3:360": 13400,
  "150:1:50": -1600,
  "150:1:100": 0,
  "150:1:150": 1000,
  "150:1:200": 2400,
  "150:1:250": 2400,
  "150:1:300": 6700,
  "150:1:360": 6700,
  "150:2:50": -3200,
  "150:2:100": 0,
  "150:2:150": 1000,
  "150:2:200": 3800,
  "150:2:250": 3800,
  "150:2:300": 10200,
  "150:2:360": 10200,
  "150:3:50": -4800,
  "150:3:100": 0,
  "150:3:150": 1000,
  "150:3:200": 5200,
  "150:3:250": 5200,
  "150:3:300": 13700,
  "150:3:360": 13700,
  "160:1:50": -1800,
  "160:1:100": 0,
  "160:1:150": 1000,
  "160:1:200": 2200,
  "160:1:250": 2200,
  "160:1:300": 6600,
  "160:1:360": 6600,
  "160:2:50": -3600,
  "160:2:100": 0,
  "160:2:150": 1000,
  "160:2:200": 3400,
  "160:2:250": 3400,
  "160:2:300": 10000,
  "160:2:360": 10000,
  "160:3:50": -5400,
  "160:3:100": 0,
  "160:3:150": 1000,
  "160:3:200": 4600,
  "160:3:250": 4600,
  "160:3:300": 13400,
  "160:3:360": 13400,
  "180:1:50": -1900,
  "180:1:100": 0,
  "180:1:150": 1000,
  "180:1:200": 2200,
  "180:1:250": 2200,
  "180:1:300": 6600,
  "180:1:360": 6600,
  "180:2:50": -3800,
  "180:2:100": 0,
  "180:2:150": 1000,
  "180:2:200": 3400,
  "180:2:250": 3400,
  "180:2:300": 10000,
  "180:2:360": 10000,
  "180:3:50": -5700,
  "180:3:100": 0,
  "180:3:150": 1000,
  "180:3:200": 4600,
  "180:3:250": 4600,
  "180:3:300": 13400,
  "180:3:360": 13400,
  "200:1:50": -3000,
  "200:1:100": 0,
  "200:1:150": 0,
  "200:1:200": 1200,
  "200:1:250": 3400,
  "200:1:300": 5800,
  "200:1:360": 5800,
  "200:2:50": -5000,
  "200:2:100": 0,
  "200:2:150": 0,
  "200:2:200": 2400,
  "200:2:250": 4600,
  "200:2:300": 9400,
  "200:2:360": 9400,
  "200:3:50": -7000,
  "200:3:100": 0,
  "200:3:150": 0,
  "200:3:200": 3600,
  "200:3:250": 5800,
  "200:3:300": 13000,
  "200:3:360": 13000
});
  const HEIGHT_HOLDER_QUANTITY = Object.freeze({
  "H1": 1,
  "H2": 1,
  "H3": 1,
  "H4": 1,
  "H5": 1,
  "H6": 1,
  "H7": 2,
  "H8": 2,
  "H9": 2,
  "H10": 2,
  "H11": 3
});

  function key(dn, heightClassId, wallDistanceMm) {
    return `${Number(dn)}:${String(heightClassId || '').toUpperCase()}:${Number(wallDistanceMm)}`;
  }

  function getPriceCents(dn, heightClassId, wallDistanceMm) {
    const height = String(heightClassId || '').toUpperCase();
    const core = CORE_PRICES_CENTS[`${Number(dn)}:${height}`];
    const holderQuantity = HEIGHT_HOLDER_QUANTITY[height];
    const delta = WALL_DISTANCE_DELTAS_CENTS[`${Number(dn)}:${holderQuantity}:${Number(wallDistanceMm)}`];
    return Number.isInteger(core) && Number.isInteger(delta) ? core + delta : null;
  }

  const api = Object.freeze({
    INTERNAL_FREIGHT_BUFFER_NET_CENTS,
    ESTIMATE_STATUS,
    CORE_PRICES_CENTS,
    WALL_DISTANCE_DELTAS_CENTS,
    HEIGHT_HOLDER_QUANTITY,
    key,
    getPriceCents
  });
  global.JeremiasDwEcoPreviewPricing = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
